"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "golfo-aranci": {
    "8f1183d7": [{
      "hkey": "bc793b88",
      "slug": "nodu-pianu-sos-aranzos",
      "name": "Nodu Pianu-Sos Aranzos",
      "primary": true,
      "skipSearch": false
    }],
    "nodu-pianu": [{
      "hkey": "bc793b88",
      "slug": "nodu-pianu-sos-aranzos",
      "name": "Nodu Pianu-Sos Aranzos",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "91073350": [{
      "hkey": "a73af803",
      "slug": "punta-pedrosa-terrata",
      "name": "Punta Pedrosa-Terrata",
      "primary": true,
      "skipSearch": false
    }],
    "punta-pedrosa-cala-sassari": [{
      "hkey": "a73af803",
      "slug": "punta-pedrosa-terrata",
      "name": "Punta Pedrosa-Terrata",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "198ce187": [{
      "hkey": "bc793b88",
      "slug": "nodu-pianu-sos-aranzos",
      "name": "Nodu Pianu-Sos Aranzos",
      "primary": true,
      "skipSearch": false
    }],
    "sos-aranzos": [{
      "hkey": "bc793b88",
      "slug": "nodu-pianu-sos-aranzos",
      "name": "Nodu Pianu-Sos Aranzos",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "golfo-aranci"
    }],
    "ccb7f4d9": [{
      "hkey": "a73af803",
      "slug": "punta-pedrosa-terrata",
      "name": "Punta Pedrosa-Terrata",
      "primary": true,
      "skipSearch": false
    }],
    "terrata": [{
      "hkey": "a73af803",
      "slug": "punta-pedrosa-terrata",
      "name": "Punta Pedrosa-Terrata",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "golfo-aranci"
    }],
    "1cb1e8b5": [{
      "hkey": "1b26a3e2",
      "slug": "spiaggia-bianca-cala-delfino",
      "name": "Spiaggia Bianca-Cala Delfino",
      "primary": true,
      "skipSearch": false
    }],
    "cala-delfino": [{
      "hkey": "1b26a3e2",
      "slug": "spiaggia-bianca-cala-delfino",
      "name": "Spiaggia Bianca-Cala Delfino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "cala-sassari": [{
      "hkey": "a73af803",
      "slug": "punta-pedrosa-terrata",
      "name": "Punta Pedrosa-Terrata",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "dd3003e9": [{
      "hkey": "a73af803",
      "slug": "punta-pedrosa-terrata",
      "name": "Punta Pedrosa-Terrata",
      "primary": true,
      "skipSearch": false
    }]
  }
};
exports["default"] = _default;